import React from "react";

// S-Suntime-PREVIEW-BANNER-REMOVE-V1 — Imports beibehalten fuer einfache Reaktivierung.
// eslint-disable-next-line no-unused-vars
import { getEnvironment, getEnvironmentLabel, ENV_LIVE } from "../../utils/environment";

// S2 — Sticky Environment-Banner (2026-04-23)
// Rendert einen breiten, nicht schließbaren Sticky-Banner, wenn die Umgebung
// NICHT Live ist. Auf Live wird nichts gerendert (null).
//
// Doktrin: „LIVE = einzige operative Wahrheit". Preview/Dev sollen visuell
// nicht mehr mit Live verwechselt werden können.

export function EnvironmentBanner() {
  // S-Suntime-PREVIEW-BANNER-REMOVE-V1 (2026-05-10)
  // Banner-Rendering deaktiviert auf Wunsch des Architekten.
  // Doktrin „Preview ist Preview" bleibt technisch gueltig (Backend/DB unveraendert),
  // nur der visuelle Hinweis wird ausgeblendet, weil er Bedienelemente verdeckt.
  // Komponente bleibt importiert/eingebunden fuer einfache Reaktivierung im Bedarfsfall.
  return null;
}

export default EnvironmentBanner;
